import styled from 'styled-components';

/**
 * SplitToolbar separates its children. 
 * Example shown uses two children, but would
 * add equal spacing for any number of children.
 ___________________________________
 |                                 |
 | Child1                   Child2 |
 |_________________________________|
 */

const SplitToolbar = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: ${({ alignment = 'center' }) =>
        alignment === 'top' ? 'flex-start' : alignment === 'bottom' ? 'flex-end' : alignment};
    min-height: 2em;
    margin-bottom: 0.5em;
`;

export default SplitToolbar;
